import { ACCOUNTS } from "../constants";
import { apiRequestTypes } from "../constants/service";
import { sendProfileServiceRequest } from "./profile-service";
import { newSendApiRequest } from "./service-gateway"

export const getXamUser = async (token, activeClientId) =>  await sendProfileServiceRequest({
    endpoint: 'xamuser',
    propsToken: token,
    propsActiveClientId: activeClientId,
    requesType: apiRequestTypes.get,
});

export const getXamUserMls = async (token, activeClientId) => await newSendApiRequest(
    'XamUserMls_read',
    [],
    undefined,
    token,
    true,
    activeClientId,
    apiRequestTypes.post,
);

export const createAgent = async (agentId, mlsId) => {
    return await newSendApiRequest(
        'XamUserMls_create',
        [
            {
                parameter: "mlsId",
                value: mlsId
            },
            {
                parameter: "agentId",
                value: agentId
            }
        ]
    );
};

export const getXamInternalUserPrivileges = async () => {
    return await newSendApiRequest(
        'internal_account_privileges',
        [
            {
                parameter: "accountId",
                value: String(ACCOUNTS.LONE_WOLF_INTERNAL.id)
            }
        ]
    );
};
